module.exports = __webpack_public_path__ + "static/favicon.c87873c5.ico";


//////////////////
// WEBPACK FOOTER
// ./src/img/favicon.ico
// module id = 64
// module chunks = 35783957827783 162898551421021 251080691916612